/**
 * Created by evgenijsenkevic on 01.10.2024
 */

FogTileView.prototype.showGroundStateAnimation = function (silent) {
    this.startFogDisappearAnimation(silent);
    this.addParticles();
    this.addLight();
};

FogTileView.prototype.createFakeUnitNode = function (fakeUnit) {
    if (Families[fakeUnit.code].units[fakeUnit.stage].invisible) {
        return;
    }

    const unitNode = new cc.Node();
    const unitImage = UnitView.getUnitImage(fakeUnit, {
        keepLazy: true,
        alignAnchorX: true,
        alignAnchorY: true
    });

    unitNode.setAnchorPoint(unitImage.anchorX, unitImage.anchorY);
    unitNode.addChild(unitImage);
    unitNode.unitImage = unitImage;
    Map2d.currentMap.getMapView().addTile(Map2d.LAYER_UNITS, this.fogTile.x, this.fogTile.y, unitNode);

    return unitNode;
};

FogTileView.prototype.onOpenFogBlock = function () {
    delete this.fogBlockView;
    this.addFlashLight();
};

FogTileView.prototype.addFlashLight = function () {
    const flashLight = new cleverapps.Spine(bundles.fog.jsons.fog_flashlight);
    flashLight.setAnimation(0, "animation", false);

    const map2dView = Map2d.currentMap.getMapView();
    map2dView.alignViewInGrid(this.fogTile.x, this.fogTile.y, flashLight);
    flashLight.setCompleteListenerRemove();
    map2dView.animations.addChild(flashLight);
};

FogTileView.prototype.addParticles = function () {
    const particles = new cleverapps.Spine(bundles.fog.jsons.fog_particles);
    particles.setAnimation(0, "animation", true);
    particles.setTimeScale(0.5 + Math.random());
    particles.setPosition(this.sprite.width / 2, this.sprite.height / 2);
    this.sprite.addChild(particles);
};

FogTileView.prototype.addLight = function () {
    for (let i = -1; i <= 1; i++) {
        for (let j = -1; j <= 1; j++) {
            const x = this.fogTile.x + i;
            const y = this.fogTile.y + j;

            const fog = Map2d.currentMap.getFog(x, y);

            if (!fog || this.fogTile.fogBlock.id !== fog.fogBlock.id) {
                return;
            }
        }
    }

    if (this.fogTile.x % 3 !== 0 || this.fogTile.y % 2 !== 0) {
        return;
    }

    const light = this.light = new cleverapps.Spine(bundles.fog.jsons.fog_light_ray);

    light.setAnimation(0, "animation", true);
    light.setTimeScale(0.5 + Math.random());

    const map2dView = Map2d.currentMap.getMapView();
    map2dView.alignViewInGrid(this.fogTile.x, this.fogTile.y, light);
    map2dView.animations.addChild(light);
};